import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ClientProfileManagement from './pages/client-profile-management';
import ClientSearchAndDirectory from './pages/client-search-and-directory';
import SupervisorDashboardAndAnalytics from './pages/supervisor-dashboard-and-analytics';
import SystemAdministrationPanel from './pages/system-administration-panel';
import CaseWorkerDashboard from './pages/case-worker-dashboard';
import UniqueIdGenerationSystem from './pages/unique-id-generation-system';
import AuditTrailAndComplianceViewer from './pages/audit-trail-and-compliance-viewer';
import BulkOperationsCenter from './pages/bulk-operations-center';
import UserAuthenticationAndLogin from './pages/user-authentication-and-login';
import HelpAndDocumentationCenter from './pages/help-and-documentation-center';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<CaseWorkerDashboard />} />
        <Route path="/client-profile-management" element={<ClientProfileManagement />} />
        <Route path="/client-search-and-directory" element={<ClientSearchAndDirectory />} />
        <Route path="/supervisor-dashboard-and-analytics" element={<SupervisorDashboardAndAnalytics />} />
        <Route path="/system-administration-panel" element={<SystemAdministrationPanel />} />
        <Route path="/case-worker-dashboard" element={<CaseWorkerDashboard />} />
        <Route path="/unique-id-generation-system" element={<UniqueIdGenerationSystem />} />
        <Route path="/audit-trail-and-compliance-viewer" element={<AuditTrailAndComplianceViewer />} />
        <Route path="/bulk-operations-center" element={<BulkOperationsCenter />} />
        <Route path="/user-authentication-and-login" element={<UserAuthenticationAndLogin />} />
        <Route path="/help-and-documentation-center" element={<HelpAndDocumentationCenter />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
